<!-- KpiSectionHeader.vue -->
<template>
  <div class="kpi-section-header">
    <span class="kpi-section-header__label">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'KpiSectionHeader',

  props: {
    label: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.kpi-section-header {
  padding: 0.5rem;
  // background-color: var(--bs-gray-200);
  border-bottom: 1px solid var(--bs-border-color);
}

.kpi-section-header__label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  color: var(--bs-gray-700);
  font-weight: 500;
}
</style>
